require([
    'redturtle-patterns-slider',
], function() {
    'use strict';
});

define("src/redturtle/patterns/slider/static/bundle.js", function(){});

